<template>
	<div class="installment-plan-selector">
		<div
			v-for="downPaymentProduct in downPaymentProducts"
			class="installment-plan-selector-item"
			:key="downPaymentProduct.monthlyInstallments"
		>
			<TnRadiobutton
				name="installment-plan-selector"
				:value="downPaymentProduct.monthlyInstallments"
				:checked="downPaymentProduct.monthlyInstallments === selectedDownPaymentProduct?.monthlyInstallments"
				@change="setSelectedDownPaymentProduct(downPaymentProduct)"
			>
				<template #label>
					<p class="installment-plan-label">
						<span class="price">
							{{ formatPrice.monthly(downPaymentProduct.prices.monthlyListPrice.value, { ceil: true }) }}
						</span>
						{{ `i ${downPaymentProduct.monthlyInstallments} md.` }}
					</p>
				</template>
			</TnRadiobutton>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import { formatPrice } from "~/helpers/formatting/price";
import type { DownPaymentProduct } from "../../ECommerceProductAccessories/types";

const store = useStore();
const selectedDownPaymentProduct = defineModel<DownPaymentProduct>();
const { downPaymentProducts } = defineProps<{ downPaymentProducts: DownPaymentProduct[] }>();

const setSelectedDownPaymentProduct = (downPaymentProduct: DownPaymentProduct) => {
	try {
		selectedDownPaymentProduct.value = downPaymentProduct;
		setSelectedWebShopOption(`DOWN_PAYMENT_${downPaymentProduct.monthlyInstallments}`);
	} catch (error) {
		console.error("Error setting selected down payment product", error);
	}
};

const setSelectedWebShopOption = (webShopOption: string) => {
	try {
		store.commit("ecommerce/setSelectedWebShopOption", webShopOption);
	} catch (error) {
		console.error("Error setting selected webshop option", error);
	}
};

watch(
	() => downPaymentProducts,
	() => {
		selectedDownPaymentProduct.value = downPaymentProducts.find(
			(downPaymentProduct: DownPaymentProduct) =>
				downPaymentProduct.monthlyInstallments === selectedDownPaymentProduct.value?.monthlyInstallments,
		);
	},
);
</script>

<style lang="scss" scoped>
.installment-plan-selector {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;

	.installment-plan-selector-item {
		border: 1px solid $color-neutrals-100-tint;
		border-radius: 8px;
		padding: 12px;
		width: 100%;
	}

	.installment-plan-label {
		margin-left: 16px;
		font-family: $font-family-telenor-ui;
		color: $color-neutrals-900-shade;
		font-weight: 300;
		font-size: 18px;
		line-height: 26px;

		.price {
			font-size: 18px;
			line-height: 26px;
			font-weight: 500;
			color: $color-primary-mid;
		}
	}
}
</style>
